import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { RadioButton as RadioButton$1 } from 'primereact/radiobutton';
export { RadioButton as PrimeRadioButton } from 'primereact/radiobutton';
import { forwardRef } from 'react';

function RadioButtonComponent(props, ref) {
  const {
      checked = false,
      disabled,
      readOnly,
      toggleable = false,
      onChange,
      onCheckedChange,
      onClickCapture
    } = props,
    radioProps = __rest(props, ["checked", "disabled", "readOnly", "toggleable", "onChange", "onCheckedChange", "onClickCapture"]);
  return jsx(RadioButton$1, Object.assign({}, radioProps, {
    ref: ref,
    checked: checked,
    disabled: disabled,
    readOnly: readOnly,
    onChange: event => {
      var _a;
      onChange === null || onChange === void 0 ? void 0 : onChange(event);
      onCheckedChange === null || onCheckedChange === void 0 ? void 0 : onCheckedChange((_a = event.checked) !== null && _a !== void 0 ? _a : false);
    },
    onClickCapture: event => {
      onClickCapture === null || onClickCapture === void 0 ? void 0 : onClickCapture(event);
      if (event.defaultPrevented || !toggleable || !checked || disabled || readOnly) return;
      event.preventDefault();
      event.stopPropagation();
      onCheckedChange === null || onCheckedChange === void 0 ? void 0 : onCheckedChange(false);
    }
  }));
}
const RadioButton = /*#__PURE__*/forwardRef(RadioButtonComponent);

export { RadioButton };
